export var Icon;
(function (Icon) {
    Icon["NEW_RESOURCE"] = "NEW_RESOURCE";
    Icon["CLOSE"] = "CLOSE";
    Icon["COLLAPSE_ALL"] = "COLLAPSE_ALL";
    Icon["DRAWER_CLOSE"] = "DRAWER_CLOSE";
    Icon["DRAWER_OPEN"] = "DRAWER_OPEN";
    Icon["ERROR"] = "ERROR";
    Icon["EXTERNAL_LINK"] = "EXTERNAL_LINK";
    Icon["GITHUB"] = "GITHUB";
    Icon["HEXMAP_ICON"] = "HEXMAP_ICON";
    Icon["INFO"] = "INFO";
    Icon["TOOL_BRUSH"] = "TOOL_BRUSH";
    Icon["TOOL_DRAW_RECT"] = "TOOL_DRAW_RECT";
    Icon["TOOL_ERASE"] = "TOOL_ERASE";
    Icon["TOOL_FILL"] = "TOOL_FILL";
    Icon["TOOL_PAN"] = "TOOL_PAN";
    Icon["TOOL_POINT_CLICK"] = "TOOL_POINT_CLICK";
    Icon["REDO"] = "REDO";
    Icon["UNDO"] = "UNDO";
    Icon["WARNING"] = "WARNING";
})(Icon || (Icon = {}));
//# sourceMappingURL=icon.js.map